module.exports = __webpack_public_path__ + "img/edit.97977ce1.png";